export const nonMoColor = {
    primary: '#0078d4',
    secondary: '#8cbce1',
    primaryRgb: 'rgb(0, 120, 212)',
    primaryHoverRgb: 'rgb(0, 100, 180)',
    gradient: 'linear-gradient(to right, #005bb5, #003f87, #0078d4,  #001f4d)',
};

export const appColor = {
    primary: '#498205',
    secondary: '#335B03',
    primaryRgb: 'rgb(73, 130, 5)',
    primaryHoverRgb: 'rgb(65, 117, 4)',
    gradient: 'linear-gradient(to right, yellowgreen,green,yellowgreen,yellow)',
};

export const getColors = (userIS) => userIS ? nonMoColor : appColor;

export const applyTheme = (userIS) => {
    const colors = getColors(userIS);
    const root = document.documentElement;

    Object.keys(colors).forEach((key) => {
        root.style.setProperty(`--${key}`, colors[key]);
    });
};
